import React from 'react';
import './TextblockUsage.css';

// Sections of TextblockUsageResponse in display order.
const SECTIONS = [
  { field: 'participantGroupRules', label: 'Gruppen' },
  { field: 'templateRules',         label: 'Prozessvorlagen' },
  { field: 'templateSteps',         label: 'Schritte in Prozessvorlagen' },
];

// The four system textblocks are sent by the code itself (by name), never through a mail rule.
const SYSTEM_USE = {
  login_two_factor_code: 'Login-Code (2-Faktor)',
  newsletter_confirm_subscription: 'Newsletter-Anmeldung bestätigen',
  newsletter_confirm_unsubscribe: 'Newsletter-Abmeldung auf Anforderung',
  orga_welcome: 'Willkommen im Orga-Team',
};

/**
 * "Verwendet in" of the opened textblock (GET /Textblock/{id}/Usages): group and template mail rules
 * that point to it and process template steps that send it; system blocks additionally name the
 * system mail they are. Without any assignment the block is only offered in the manual mail dialogs.
 * usage: { status: 'loading' | 'loaded' | 'failed', data } (undefined while the request starts).
 */
function TextblockUsage({ usage, textblock }) {
  const systemUse = textblock?.isSystemBlock ? (SYSTEM_USE[textblock.name] ?? 'Systemmail') : null;

  let content;
  if (!usage || usage.status === 'loading') {
    content = <p className="textblockUsageMessage">Verwendung wird geladen …</p>;
  } else if (usage.status === 'failed') {
    content = <p className="textblockUsageMessage">Verwendung konnte nicht geladen werden.</p>;
  } else {
    // De-duplicated: a template can hold one rule per group for the same slot ("Vorlage: Slot" repeats).
    const rows = SECTIONS
      .map(s => ({ ...s, entries: [...new Set(usage.data?.[s.field] ?? [])] }))
      .filter(s => s.entries.length > 0);
    if (systemUse) rows.unshift({ field: 'system', label: 'System', entries: [systemUse] });
    content = rows.length === 0
      ? <p className="textblockUsageMessage">Keiner Gruppe und keiner Prozessvorlage zugeordnet – wird nur über die Mail-Dialoge versendet.</p>
      : (
        <dl className="textblockUsageList">
          {rows.map(row => (
            <div key={row.field} className="textblockUsageRow">
              <dt className="textblockUsageLabel">{row.label}</dt>
              <dd className="textblockUsageEntries">
                {row.entries.map(entry => (
                  <span key={entry} className="textblockUsageChip">{entry}</span>
                ))}
              </dd>
            </div>
          ))}
        </dl>
      );
  }

  return (
    <section className="textblockUsage">
      <h4 className="textblockUsageTitle">
        <span className="material-symbols-rounded textblockUsageIcon" aria-hidden="true">account_tree</span>
        Verwendet in
      </h4>
      {content}
    </section>
  );
}

export default TextblockUsage;
